import { COMMON_CLASSNAMES } from '@/constants';
import DTransition from '../DTransition';

const ValidationError = ({ error }) => {
  return (
    <div className="relative h-0">
      <DTransition show={error}>
        <p
          className={`transition-all ${COMMON_CLASSNAMES.transition.duration.medium} absolute text-error h-4`}
        >
          {error}
        </p>
      </DTransition>
    </div>
  );
};

export default ValidationError;
